export const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/

export const EmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const EmailRegex2 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


export const PersonalIDRegex = /^\d{12}$/

export const PhoneRegex = {
  default: /^\d{9,12}$/,
};
